import { render, staticRenderFns } from "./LabelList.vue?vue&type=template&id=a8b16354&"
import script from "./LabelList.vue?vue&type=script&lang=tsx&"
export * from "./LabelList.vue?vue&type=script&lang=tsx&"
import style0 from "./LabelList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports